import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  surface: {
    maxWidth: "400px",
    width: "100%",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: designTokens.spacing[4],
  },
  title: {
    fontSize: designTokens.fontSize.lg,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[900],
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[4]),
    paddingTop: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[4],
  },
  qrCodeContainer: {
    ...shorthands.padding(designTokens.spacing[4]),
    backgroundColor: designTokens.neutral.white,
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  urlContainer: {
    width: "100%",
    ...shorthands.padding(designTokens.spacing[3]),
    backgroundColor: designTokens.neutral[50],
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap(designTokens.spacing[1]),
  },
  urlLabel: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[600],
    textTransform: "uppercase",
  },
  urlText: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[800],
    wordBreak: "break-all",
    lineHeight: designTokens.lineHeight.normal,
  },
  infoText: {
    display: "flex",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[1]),
    fontSize: designTokens.fontSize.xxs,
    textAlign: "start",
    overflow: "hidden",
    width: "280px",
    height: "20px",
    textOverflow: "ellipsis",
    border: `1px solid ${designTokens.accent[100]}`,
    backgroundColor: "#f5f4ed",
    borderRadius: designTokens.borderRadius.md,
    padding: designTokens.spacing[1],
    whiteSpace: "nowrap",
    cursor: "pointer",
  },
  copyStatusText: {
    fontSize: designTokens.fontSize.xxs,
    color: designTokens.accent[600],
    fontWeight: designTokens.fontWeight.medium,
    textAlign: "center",
    animation: "fadeIn 0.3s ease-in",
  },
  footer: {
    display: "flex",
    width: "100%",
    boxSizing: "border-box",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    paddingTop: designTokens.spacing[4],
    ...shorthands.gap(designTokens.spacing[2]),
  },
  linkIcon: {
    flexShrink: 0,
    paddingLeft: "3px",
    marginRight: "3px",
    paddingTop: "1px",
  },
  urlSpan: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  copyButton: {
    fontSize: "12px",
    gap: "2px",
    alignItems: "center",
    display: "flex",
  },
});
